import { TextStyleSheet } from "./text.styled";

export const Text = TextStyleSheet;
